import { getWindowInnerHeight } from './getWindowInnerHeight';
import { getWindowInnerWidth } from './getWindowInnerWidth';
export var getScaleToWindow = function (width, height, offset) {
    var scaleX = getWindowInnerWidth() / (width + offset);
    var scaleY = getWindowInnerHeight() / (height + offset);
    return Math.min(scaleX, scaleY);
};
